import { QUERYSTATE_INITIAL_STATE } from "./constants";
import { QueryReducer } from "./types";

export const queryReducer: QueryReducer = (queryState, queryAction) => {
  switch (queryAction.type) {
    case "reset":
      return QUERYSTATE_INITIAL_STATE;
    case "update_q":
      return {
        ...queryState,
        q: queryAction.value || QUERYSTATE_INITIAL_STATE.q,
      };
    case "update_custom_department":
      return {
        ...queryState,
        department: queryAction.value || QUERYSTATE_INITIAL_STATE.department,
      };
    case "update_custom_location":
      return {
        ...queryState,
        location: queryAction.value || QUERYSTATE_INITIAL_STATE.location,
      };
    case "update_custom_employmentType":
      return {
        ...queryState,
        employmentType:
          queryAction.value || QUERYSTATE_INITIAL_STATE.employmentType,
      };
    case "update_commute_filter":
      return {
        ...queryState,
        commuteFilter:
          queryAction.value || QUERYSTATE_INITIAL_STATE.commuteFilter,
      };
    case "update_commute_filter_params":
      return {
        ...queryState,
        commuteFilter: true,
        ...queryAction.value,
      };
    case "update_job_type":
      return {
        ...queryState,
        jobType: queryAction.value || QUERYSTATE_INITIAL_STATE.jobType,
      };
    case "update_job_location":
      return {
        ...queryState,
        ...queryAction.value,
      };
    default:
      console.error(
        "No Reducer Defined. QueryState Object:",
        queryState,
        queryAction
      );

      return queryState;
  }
};
